import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import { Button, Input } from '../../../../Components/StyledComponents';
import { onlyNum } from '../../../../Utils/functions';
import './PriceFee.scss';
import {cloneDeep} from 'lodash-es';

const PriceFee = ({MinDelivery,MinBaseFee,DeliveryBaseFeeByPrice, patchBaseFee}) => {
    const [ minDeliveryPrice, setMinDeliveryPrice ] = React.useState(0);//최소 주문 금액
    const [ deliveryBaseFee, setDeliveryBaseFee ] = React.useState(0);//기본 배달팁
    const [ list, setList ] = React.useState([]);//추가 금액별 배달팁 목록

    useEffect(() => {
        setMinDeliveryPrice(cloneDeep(MinDelivery));
        setDeliveryBaseFee(cloneDeep(MinBaseFee));
        if(typeof DeliveryBaseFeeByPrice !== 'undefined') setList(cloneDeep(DeliveryBaseFeeByPrice));
    },[])

    //추가 금액별 배달팁 array push
    const addList = () => {
        if(list.length > 0 ){
            if( list.length === 1 ){
                if( Number(list[list.length - 1].Price) < Number(minDeliveryPrice) || Number(list[list.length - 1].BaseFee) > Number(deliveryBaseFee) ){
                    alertRef.current.showAlert({ title : '주문 금액 또는 배달팁을 확인해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                    return
                }
            }
            if( list[list.length - 1].Price === null || list[list.length - 1].Price.length === 0 || list[list.length - 1].BaseFee === null || list[list.length - 1].BaseFee.length ===  null ){
                alertRef.current.showAlert({ title : '이전 항목을 입력해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                return;
            }else if( list.length > 1 ){
                if( Number(list[list.length - 1].Price) < Number(list[list.length - 2].Price) || Number(list[list.length - 1].BaseFee) > Number(list[list.length - 2].BaseFee) ){
                    alertRef.current.showAlert({ title : '주문 금액 또는 배달팁을 확인해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                    return;
                }
            }
        }

        let arr = list;
        arr.push({Price : 0, BaseFee : 0 })
        setList([...arr])
    }

    //추가 금액별 배달팁 array remove
    const removeList = (i) => {
        let arr = list;
        arr.splice(i,1);
        setList([...arr])
    }

    ////추가 금액별 배달팁 array[index] 의 Price value 수정
    const handleListPrice = (val,i) => {
        let arr = list;
        list[i].Price = val;
        setList([...arr])
    }

    ////추가 금액별 배달팁 array[index] 의 BaseFee value 수정
    const handleListBaseFee = (val,i) => {
        let arr = list;
        list[i].BaseFee = val;
        setList([...arr])
    }

    //validation 후 배달팁 설정
    const setDeliverFee = () => {
        if(list.length > 0 ){
            if( list.length === 1 ){
                if( Number(list[list.length - 1].Price) < Number(minDeliveryPrice) || Number(list[list.length - 1].BaseFee) > Number(deliveryBaseFee) ){
                    alertRef.current.showAlert({ title : '주문 금액 또는 배달팁을 확인해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                    return
                }
            }else {
                if( Number(list[list.length - 1].Price) < Number(list[list.length - 2].Price) || Number(list[list.length - 1].BaseFee) > Number(list[list.length - 2].BaseFee) ){
                    alertRef.current.showAlert({ title : '주문 금액 또는 배달팁을 확인해주세요.', subTitle : '', isCancel : true, cancelText : '닫기', isConfirm : false})
                    return;
                }
            }
        }

        let arr = [];
        for( let i=0; i < list.length; i++){
            arr.push({ Price : parseInt(list[i].Price), BaseFee : parseInt(list[i].BaseFee) })
        }

        patchBaseFee({
            MinDeliveryPrice : parseInt(minDeliveryPrice),
            DeliveryBaseFee : parseInt(deliveryBaseFee),
            DeliveryBaseFeeByPrice : arr
        })
    }

    return (
        <div className='price-fee'>
            <p className='label'>최소 주문 금액</p>
            <div className='row'>
                <p className='input-text'>최소</p>
                <label data-domain="원">
                    <Input value={minDeliveryPrice} onChange={(e) => setMinDeliveryPrice(onlyNum(e.target.value))} style={{ width : 160, marginLeft : 8, marginRight : 8 }} />
                </label>
                <p className='input-text'>이상 주문시</p>
                <p className='input-text' style={{ marginLeft : 16 }}>배달팁</p>
                <label data-domain="원">
                    <Input value={deliveryBaseFee} onChange={(e) => setDeliveryBaseFee(onlyNum(e.target.value))} style={{ width : 160, marginLeft : 8 }} />
                </label>
            </div>

            <div className='divider'/>
            <p className='label' style={{ marginBottom : 8 }}>추가 금액별 배달팁</p>

            {
                list.length > 0 &&
                <div style={{ marginBottom : 16 }}>
                    <p className='warn-text'>* 주문 금액은 이전 항목 또는 최소주문금액 보다 많아야 합니다.</p>
                    <p className='warn-text'>* 배달팁은 이전 항목 또는 최소 배달팁 보다 적어야 합니다.</p>
                </div>
            }

            {
                list.map((data,i) => {
                    return(
                        <div className='row' style={{ marginBottom : 16 }} key={i}>
                            <label data-domain="원">
                                <Input value={list[i].Price} onChange={(e) => handleListPrice(onlyNum(e.target.value),i)} style={{ width : 160, marginRight : 8 }} />
                            </label>
                            <p className='input-text'>이상 주문시</p>
                            <p className='input-text' style={{ marginLeft : 16 }}>배달팁</p>
                            <label data-domain="원">
                                <Input value={list[i].BaseFee} onChange={(e) => handleListBaseFee(onlyNum(e.target.value),i)} style={{ width : 160, marginLeft : 8 }} />
                            </label>
                            <Button variant="sub" onClick={()=> removeList(i)} style={{ width : 24, height : 24, borderRadius : 100, boxSizing : 'border-box', padding : 0, marginLeft : 8 }}>
                                <img src={require('../../../../aseets/icons/minus_pink.svg').default} style={{ width : 21, height : 21, marginTop : 2 }} />
                            </Button>
                        </div>
                    ) 
                })
            }

            <Button variant="sub" onClick={() => addList()} small style={{ paddingLeft : 16, paddingRight : 16 }}>
                <div className='row'>
                    <img src={require('../../../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                    추가하기
                </div>
            </Button>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={() => setDeliverFee()}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default PriceFee;